import React, { useState, useEffect } from "react";
import "../style/slider_homepage.css";

const slide00 = "https://ik.imagekit.io/axiomhives/parm_assets/image_slider_homepage/RAYA_BANNER_NEW1.png?updatedAt=1773930112509";
const slide0 = "https://ik.imagekit.io/axiomhives/parm_assets/image_slider_homepage/PArM%20Web%20Banner_Ramadan.png?updatedAt=1771484725305";
const slide1 = "https://ik.imagekit.io/axiomhives/parm_assets/intac_kl/INTAC_BANNER_NEW.png?updatedAt=1769929468176";
const slide2 = "https://ik.imagekit.io/axiomhives/parm_assets/aptcc/acp_banner.jpeg?updatedAt=1769929469314";
const slide3 = "https://ik.imagekit.io/axiomhives/parm_assets/image_slider_homepage/parm2.jpeg?updatedAt=1769929450568";
const slide4 = "https://ik.imagekit.io/axiomhives/parm_assets/image_slider_homepage/parm1.png?updatedAt=1769929450353";
const slide5 = "https://ik.imagekit.io/axiomhives/parm_assets/image_slider_homepage/parm3.jpeg?updatedAt=1769929447782";
const slide6 = "https://ik.imagekit.io/axiomhives/parm_assets/parm-banner-copy%20(1).jpg";

const Slider = () => {
  const slides = [slide1, slide2, slide6, slide3, slide4, slide5];
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {setCurrent((prev) => (prev + 1) % slides.length);}, 30000);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <div className="slider-wrapper">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === current ? "active" : ""}`}
          >
            <img src={slide} alt={`slide-${index}`} className="slide-image" />
          </div>
        ))}

        <div className="dots">
          {slides.map((_, index) => (
            <span
              key={index}
              className={`dot ${index === current ? "active-dot" : ""}`}
              onClick={() => setCurrent(index)}
            ></span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Slider;